import type { NextPage } from "next";
import type { SVGProps } from "react";

import { PerkType } from "@/libs/client/goApi/flight/flightServiceInterfaces/getFlightFaresInterface";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
  tagType?: PerkType;
}

const ExtraBenefitIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "ExtraBenefitIconGradient",
  isGradient = false,
  tagType = PerkType.freebie,
  ...props
}) => {
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {tagType === PerkType.freebie ? (
        <svg
          width="25"
          height="24"
          viewBox="0 0 25 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          {isGradient && (
            <defs>
              <linearGradient id={gradientId}>
                <stop offset="0%" stopColor={from} />
                <stop offset="100%" stopColor={to} />
              </linearGradient>
            </defs>
          )}

          <path
            d="M3.80957 10.5V8.25C3.80957 7.83579 4.14536 7.5 4.55957 7.5H10.5596V10.5H3.80957Z"
            fill="#042A45"
          />
          <path d="M11.3096 21V7.5H14.3096V21H11.3096Z" fill="#042A45" />
          <path
            d="M15.0596 10.5V7.5H21.0596C21.4738 7.5 21.8096 7.83579 21.8096 8.25V10.5H15.0596Z"
            fill="#042A45"
          />
          <path
            d="M10.5596 21V11.25H4.55957V20.25C4.55957 20.6642 4.89536 21 5.30957 21H10.5596Z"
            fill="#52A4FF"
          />
          <path
            d="M15.0596 21V11.25H21.0596V20.25C21.0596 20.6642 20.7238 21 20.3096 21H15.0596Z"
            fill="#52A4FF"
          />
          <path
            d="M6.80959 6.75V5.23296C6.80959 4.66285 6.80085 4.03396 7.16028 3.55901C7.74725 2.78336 8.71153 2.92716 9.47863 3.31583C11.0802 4.127 12.4717 5.30486 13.5596 6.75H6.80959Z"
            fill="#042A45"
          />
          <path
            d="M18.8096 6.75V5.23296C18.8096 4.66285 18.8183 4.03396 18.4589 3.55901C17.8719 2.78336 16.9076 2.92716 16.1405 3.31583C14.5389 4.127 13.1474 5.30486 12.0596 6.75H18.8096Z"
            fill="#042A45"
          />
          <path
            d="M11.3096 5.25C11.3096 4.83579 11.6454 4.5 12.0596 4.5H13.5596C13.9738 4.5 14.3096 4.83579 14.3096 5.25V6C14.3096 6.41421 13.9738 6.75 13.5596 6.75H12.0596C11.6454 6.75 11.3096 6.41421 11.3096 6V5.25Z"
            fill="#042A45"
          />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          {...props}
        >
          <path
            d="M2 7V5.5C2 5.22386 2.22386 5 2.5 5H6.5V7H2Z"
            fill="url(#paint0_linear_7804_460835)"
          />
          <path d="M7 14V5H9V14H7Z" fill="url(#paint1_linear_7804_460835)" />
          <path
            d="M9.5 7V5H13.5C13.7761 5 14 5.22386 14 5.5V7H9.5Z"
            fill="url(#paint2_linear_7804_460835)"
          />
          <path
            d="M6.5 14V7.5H2.5V13.5C2.5 13.7761 2.72386 14 3 14H6.5Z"
            fill="url(#paint3_linear_7804_460835)"
          />
          <path
            d="M9.5 14V7.5H13.5V13.5C13.5 13.7761 13.2761 14 13 14H9.5Z"
            fill="url(#paint4_linear_7804_460835)"
          />
          <path
            d="M4.00001 4.5V3.48864C4.00001 3.10857 3.99419 2.68931 4.2338 2.37268C4.62512 1.85558 5.26797 1.95144 5.77937 2.21055C6.8471 2.75134 7.77478 3.53657 8.5 4.5H4.00001Z"
            fill="url(#paint5_linear_7804_460835)"
          />
          <path
            d="M12 4.5V3.48864C12 3.10857 12.0058 2.68931 11.7662 2.37268C11.3749 1.85558 10.732 1.95144 10.2206 2.21055C9.1529 2.75134 8.22522 3.53657 7.5 4.5H12Z"
            fill="url(#paint6_linear_7804_460835)"
          />
          <path
            d="M7 3.5C7 3.22386 7.22386 3 7.5 3H8.5C8.77614 3 9 3.22386 9 3.5V4C9 4.27614 8.77614 4.5 8.5 4.5H7.5C7.22386 4.5 7 4.27614 7 4V3.5Z"
            fill="url(#paint7_linear_7804_460835)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_7804_460835"
              x1="2"
              y1="6"
              x2="6.45681"
              y2="5.56127"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#2B292E" />
              <stop offset="1" stopColor="#5A575C" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_7804_460835"
              x1="7"
              y1="9.5"
              x2="8.99981"
              y2="9.48056"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#2B292E" />
              <stop offset="1" stopColor="#5A575C" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_7804_460835"
              x1="9.5"
              y1="6"
              x2="13.9568"
              y2="5.56127"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#2B292E" />
              <stop offset="1" stopColor="#5A575C" />
            </linearGradient>
            <linearGradient
              id="paint3_linear_7804_460835"
              x1="6.5"
              y1="11.3505"
              x2="2.5"
              y2="11.3505"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#BD2414" />
              <stop offset="1" stopColor="#DD3422" />
            </linearGradient>
            <linearGradient
              id="paint4_linear_7804_460835"
              x1="9.5"
              y1="11.3505"
              x2="13.5"
              y2="11.3505"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#BD2414" />
              <stop offset="1" stopColor="#DD3422" />
            </linearGradient>
            <linearGradient
              id="paint5_linear_7804_460835"
              x1="4"
              y1="3.25"
              x2="8.47226"
              y2="2.8978"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#2B292E" />
              <stop offset="1" stopColor="#5A575C" />
            </linearGradient>
            <linearGradient
              id="paint6_linear_7804_460835"
              x1="12"
              y1="3.25"
              x2="7.52774"
              y2="2.8978"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#2B292E" />
              <stop offset="1" stopColor="#5A575C" />
            </linearGradient>
            <linearGradient
              id="paint7_linear_7804_460835"
              x1="7"
              y1="3.75"
              x2="8.99322"
              y2="3.63373"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#2B292E" />
              <stop offset="1" stopColor="#5A575C" />
            </linearGradient>
          </defs>
        </svg>
      )}
    </>
  );
};

export default ExtraBenefitIcon;
